import * as React from 'react';
import { Tooltip, Link } from '@grandvisionhq/common';
import { Text, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useCancelAndReturnsModalContentSlot } from '../../../context/CancelAndReturnsModalContentContext.js';
import CancelAndReturnsModal from '../CancelAndReturns/CancelAndReturnsModal.js';

const OrderHeader = ({ orderDate , orderNumber , shipmentStatus , paymentStatus , isPaid , receiptUrl , shipmentTrackingUrl , onTraceOrder , onReorder , onOpenCancelReturnsModal , onCloseCancelReturnsModal , onDownloadReceiptClick , isCancelReturnsModalOpen ,  })=>{
    const { dateTime , getLabel  } = useIntl();
    const { Slots  } = useCancelAndReturnsModalContentSlot();
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-header"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, dateTime.formatLongDate(orderDate)), /*#__PURE__*/ React.createElement(Heading, {
        variant: "small"
    }, getLabel('common.order'), " #", orderNumber), /*#__PURE__*/ React.createElement("div", {
        className: "order-header__status"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-header__status-detail"
    }, paymentStatus && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, getLabel('account.order.paymentStatus.label'), ":", /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__status-detail__text",
        variant: "list"
    }, paymentStatus, /*#__PURE__*/ React.createElement(Tooltip, {
        className: "order-header__tooltip",
        id: "tooltip-payment",
        message: getLabel('account.order.paymentStatus.tooltip')
    })))), shipmentStatus && /*#__PURE__*/ React.createElement("div", {
        className: "order-header__details"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, getLabel('account.order.shipmentState.label'), ":", /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__status-detail__text",
        variant: "list"
    }, shipmentStatus, /*#__PURE__*/ React.createElement(Tooltip, {
        className: "order-header__tooltip",
        id: "tooltip-shipment",
        message: getLabel('account.order.shipmentState.tooltip')
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "order-header__links"
    }, onReorder && /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__link",
        variant: "list"
    }, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "add-to-cart",
        onClick: ()=>onReorder()
    }, getLabel('account.action.reOrder'))), shipmentTrackingUrl && /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__link",
        variant: "list"
    }, /*#__PURE__*/ React.createElement(Link, {
        url: shipmentTrackingUrl,
        iconBefore: "location",
        onClick: onTraceOrder,
        target: "_blank"
    }, getLabel('account.order.trackingURL.label'))), isPaid && receiptUrl && /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__link",
        variant: "list"
    }, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "printer",
        url: receiptUrl,
        onClick: onDownloadReceiptClick
    }, getLabel('common.payment.downloadReceipt'))), Slots.ModalContent && isPaid && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__link",
        variant: "list"
    }, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "returns",
        onClick: onOpenCancelReturnsModal
    }, getLabel('account.cancelAndReturns.label'))), isCancelReturnsModalOpen && /*#__PURE__*/ React.createElement(CancelAndReturnsModal, {
        ModalContent: Slots.ModalContent,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal
    }))));
};
var OrderHeader$1 = OrderHeader;

export { OrderHeader$1 as default };
//# sourceMappingURL=OrderHeader.js.map
